import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";

const RewardCoupon = props =>{
    useStyles(cls);
    const { rewardCoupon } = props;

    return <div className={cls.RewardCoupon}>
        <div className={cls.Hd}>
            <span>{rewardCoupon?.title}</span>

            {
                rewardCoupon?.label && <span className={cls.CouponBundle}>
                    <span>{rewardCoupon.label}</span>
                </span>
            }
        </div>
        
        {
            rewardCoupon?.description && <div className={cls.Bd}>
                <span dangerouslySetInnerHTML={{ __html: rewardCoupon.description }}></span>
            </div>
        }
    </div>
}

export default RewardCoupon;